import { render, staticRenderFns } from "./DribblingPage.vue?vue&type=template&id=488da351&"
import script from "./DribblingPage.vue?vue&type=script&lang=js&"
export * from "./DribblingPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports